module.exports = __webpack_public_path__ + "img/env.399797ca.png";